import { useReducer } from 'react';
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import reducer, { defaultState, updateFieldCreator } from './reducer';
import {
  createMaCisCreator,
  setMaCisCreateErrorsCreator,
} from '../../../../../store/actionsCreators';
import AddCertificateHolder from '../../../../../shared/Cis/CertificateHolders/Add/AddCertificateHolder';

const AddMaCertificateHolder = ({ errors, createCertificateHolder, removeError, created }) => {
  const [state, dispatch] = useReducer(reducer, defaultState);

  return (
    <AddCertificateHolder
      state={state}
      dispatch={dispatch}
      updateFieldCreator={updateFieldCreator}
      errors={errors}
      createCertificateHolder={createCertificateHolder}
      removeError={removeError}
      created={created}
      type="ma"
    />
  );
};

AddMaCertificateHolder.propTypes = {
  errors: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    title: PropTypes.string,
    middleName: PropTypes.string,
    birthDate: PropTypes.string,
    status: PropTypes.string,
  }),
  createCertificateHolder: PropTypes.func.isRequired,
  removeError: PropTypes.func.isRequired,
  created: PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  }),
};

AddMaCertificateHolder.defaultProps = {
  errors: {},
  created: {},
};

const mapStateToProps = ({ ma }) => ({
  errors: ma.cis.certificateHolders.createErrors,
  created: ma.cis.certificateHolders.created,
});

const mapDispatchToProps = (dispatch) => ({
  createCertificateHolder: (payload, history) =>
    dispatch(createMaCisCreator('certificateHolders', payload, history, false)),
  removeError: (payload) => dispatch(setMaCisCreateErrorsCreator('certificateHolders', payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddMaCertificateHolder);
